<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
<div>
  <router-link
    :to="{name: 'userpage', params: {type: 'profile', id: news.textParams[0]}}"
    class="member-name"
  >{{news.textParams[1]}}</router-link>
  {{$t('news.template.proposal.publishByMember.p1')}}
  <router-link
    :to="{name: 'ProposalView', params: {id: news.textParams[3]}}"
  >{{news.textParams[4]}}</router-link>
  {{$t('news.template.proposal.publishByMember.p2')}}
  <router-link :to="{name: 'forum', params: {id: news.textParams[5]}}"
  >{{news.textParams[6]}}</router-link>
</div>
</template>
